module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "flex-grid a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item"
  }, [_c('control', {
    attrs: {
      "label": "Select Ogden Table Discount Rate"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discountRate),
      expression: "discountRate"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.discountRate = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": -2.0
    }
  }, [_vm._v("-2.00%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -1.5
    }
  }, [_vm._v("-1.50%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -1.0
    }
  }, [_vm._v("-1.00%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -0.75
    }
  }, [_vm._v("-0.75%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -0.5
    }
  }, [_vm._v("-0.50%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -0.25
    }
  }, [_vm._v("-0.25%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 0.0
    }
  }, [_vm._v("0.00%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 0.5
    }
  }, [_vm._v("0.50%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1.0
    }
  }, [_vm._v("1.00%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1.5
    }
  }, [_vm._v("1.50%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2.0
    }
  }, [_vm._v("2.00%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2.5
    }
  }, [_vm._v("2.50%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3.0
    }
  }, [_vm._v("3.00%")])])]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Assumed Settlement",
      "for": "assumed_settlement"
    }
  }, [_c('input', {
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "readonly": "",
      "disabled": ""
    },
    domProps: {
      "value": _vm.claimDetails('assumedSettlement')
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Period Between DOD & Settlement",
      "for": "period_between_dod_and_settlement",
      "before-after": "years"
    }
  }, [_c('input', {
    attrs: {
      "autocomplete": "off",
      "readonly": "",
      "disabled": "",
      "type": "text",
      "id": "period_between_dod_and_settlement"
    },
    domProps: {
      "value": _vm.deceasedDetails('periodDeathToSettlement')
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Deceased's Age at Assumed Settlement",
      "for": "deceased_age_at_settlement"
    }
  }, [_c('input', {
    attrs: {
      "autocomplete": "off",
      "readonly": "",
      "disabled": "",
      "type": "text",
      "id": "deceased_age_at_settlement"
    },
    domProps: {
      "value": _vm.deceasedDetails('ageAtSettlement')
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Period from Settlement to End of Dependency",
      "before-after": "years"
    }
  }, [_c('input', {
    attrs: {
      "autocomplete": "off",
      "readonly": "",
      "disabled": "",
      "type": "text",
      "id": "period_from_settlement_to_end_of_dependency"
    },
    domProps: {
      "value": _vm.roundValue(_vm.periodSettlementToEnd, 2)
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item flex-grid--space-left"
  }, [_c('control', {
    attrs: {
      "label": "Select Ogden Table"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discountTable),
      expression: "discountTable"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.discountTable = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("Table 1 or 2")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 28
    }
  }, [_vm._v("Table 36")])])]), _vm._v(" "), (_vm.discountTable === 1) ? _c('control', {
    attrs: {
      "label": _vm.table1Or2Label,
      "for": "ogden_table_multiplier",
      "tip-icon": 'formula',
      "tip-text": "Click to view calculation",
      "tip-side": "left",
      "tip-width": "140",
      "tip-name": "ogden_table_multiplier_1",
      "modal-name": 'multipliers_' + _vm.uniqueId,
      "endpoint": 'table1and2',
      "payload": _vm.multiplierPayload
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "readonly": "",
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.multipliers.table1Or2Multiplier
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.discountTable === 28) ? _c('control', {
    attrs: {
      "label": "Ogden Table 36 Multiplier",
      "for": "ogden_table_multiplier",
      "tip-icon": 'formula',
      "tip-text": "Click to view calculation",
      "tip-side": "left",
      "tip-width": "140",
      "tip-name": "ogden_table_multiplier_28",
      "modal-name": 'multipliers_' + _vm.uniqueId,
      "endpoint": 'table28',
      "payload": _vm.multiplierPayload
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "readonly": "",
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.multipliers.table28Multiplier
    }
  })]) : _vm._e(), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Ogden Table E Pre-Assessment Discount",
      "for": "ogden_table_pre_assesmentment",
      "tip-icon": 'formula',
      "tip-text": "Click to view calculation",
      "tip-side": "left",
      "tip-width": "140",
      "tip-name": "ogden_table_pre_assesmentment",
      "modal-name": 'multipliers_' + _vm.uniqueId,
      "endpoint": 'pre',
      "payload": _vm.preAndPostAssessmentPayload
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "readonly": "",
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.multipliers.preAssessmentDiscount
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Ogden Table F Post-Assessment Discount",
      "for": "ogden_table_post_assesmentment",
      "tip-icon": 'formula',
      "tip-text": "Click to view calculation",
      "tip-side": "left",
      "tip-width": "140",
      "tip-name": "ogden_table_post_assesmentment",
      "modal-name": 'multipliers_' + _vm.uniqueId,
      "endpoint": 'post',
      "payload": _vm.preAndPostAssessmentPayload
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "readonly": "",
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.multipliers.postAssessmentDiscount
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Calculated Income Dependency",
      "for": "calculated_income_dod",
      "before-after": "pound"
    }
  }, [_c('input', {
    attrs: {
      "autocomplete": "off",
      "readonly": "",
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.currencyFormat(_vm.calculatedIncomeDependency, '')
    }
  })])], 1)]), _vm._v(" "), (_vm.discountTable === 28) ? _c('div', {
    staticClass: "a-table a-table--short-no-style a-table--really-wide"
  }, [_c('div', {
    class: {
      'a-loader--table': !_vm.multiplierTable.length
    }
  }), _vm._v(" "), (_vm.multiplierTable.length) ? _c('table', {
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Period")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Dates (from–to)")]), _vm._v(" "), _c('th', [_vm._v("Duration (years)")]), _vm._v(" "), _c('th', [_vm._v("Number of Dependants")]), _vm._v(" "), (_vm.theMultiplicand.method != 'multiplicand_pounds') ? _c('th', [_vm._v("Dependency Formula")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("Dependency Multiplicand")]), _vm._v(" "), _c('th', [_vm._v("Multiplier")]), _vm._v(" "), _c('th', [_vm._v("Discount Factor")]), _vm._v(" "), (_vm.theDeceased.income.contingencyMultiplier) ? _c('th', [_vm._v("Employment Contingency Multiplier")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("Discounted Multiplier")]), _vm._v(" "), _c('th', [_vm._v("Dependency Value")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.multiplierTable), function(row) {
    return _c('tr', [_c('th', [_vm._v(_vm._s(row.period == 'pre' ? 'Pre-Assessment' : 'Post-Assessment'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.start))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.end))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(row.duration, 2)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.numberOfDependants))]), _vm._v(" "), (_vm.theMultiplicand.method == 'multiplicand_default' && row.numberOfDependants == 1) ? _c('td', [_c('svg', {
      attrs: {
        "version": "1.1",
        "x": "0px",
        "y": "0px",
        "viewBox": "0 -3 360 30",
        "width": "360",
        "height": "38"
      }
    }, [_c('text', {
      attrs: {
        "transform": "matrix(1 0 0 1 5 10.283)"
      }
    }, [_vm._v("2")]), _vm._v(" "), _c('text', {
      attrs: {
        "transform": "matrix(1 0 0 1 5 31)"
      }
    }, [_vm._v("3")]), _vm._v(" "), _c('line', {
      staticClass: "a-formula-svg__line",
      attrs: {
        "x1": "0",
        "y1": "15.8",
        "x2": "18",
        "y2": "15.8"
      }
    }), _vm._v(" "), _c('text', {
      attrs: {
        "transform": "matrix(1 0 0 1 23.6665 18.9495)"
      }
    }, [_vm._v("x")]), _vm._v(" "), _c('text', {
      attrs: {
        "transform": "matrix(1 0 0 1 36.6665 19.283)"
      }
    }, [_vm._v("[ " + _vm._s(_vm.currencyFormat(row.formula.deceasedNet)) + " + " + _vm._s(_vm.currencyFormat(row.formula.dependantsNet)) + " ] - " + _vm._s(_vm.currencyFormat(row.formula.dependantsNet)))])])]) : _vm._e(), _vm._v(" "), (_vm.theMultiplicand.method == 'multiplicand_default' && row.numberOfDependants > 1) ? _c('td', [_c('svg', {
      attrs: {
        "version": "1.1",
        "x": "0px",
        "y": "0px",
        "viewBox": "0 -3 360 30",
        "width": "360",
        "height": "38"
      }
    }, [_c('text', {
      attrs: {
        "transform": "matrix(1 0 0 1 5 18.9495)"
      }
    }, [_vm._v("75%")]), _vm._v(" "), _c('text', {
      attrs: {
        "transform": "matrix(1 0 0 1 38.6665 18.9495)"
      }
    }, [_vm._v("x")]), _vm._v(" "), _c('text', {
      attrs: {
        "transform": "matrix(1 0 0 1 48.6665 19.283)"
      }
    }, [_vm._v("[ " + _vm._s(_vm.currencyFormat(row.formula.deceasedNet)) + " + " + _vm._s(_vm.currencyFormat(row.formula.dependantsNet)) + " ] - " + _vm._s(_vm.currencyFormat(row.formula.dependantsNet)))])])]) : _vm._e(), _vm._v(" "), (_vm.theMultiplicand.method == 'multiplicand_percentage') ? _c('td', [_c('svg', {
      attrs: {
        "version": "1.1",
        "x": "0px",
        "y": "0px",
        "viewBox": "0 -3 360 30",
        "width": "360",
        "height": "38"
      }
    }, [_c('text', {
      attrs: {
        "transform": "matrix(1 0 0 1 5 18.9495)"
      }
    }, [_vm._v(_vm._s(_vm.theMultiplicand.percentage) + "%")]), _vm._v(" "), _c('text', {
      attrs: {
        "transform": "matrix(1 0 0 1 38.6665 18.9495)"
      }
    }, [_vm._v("x")]), _vm._v(" "), _c('text', {
      attrs: {
        "transform": "matrix(1 0 0 1 48.6665 19.283)"
      }
    }, [_vm._v("[ " + _vm._s(_vm.currencyFormat(row.formula.deceasedNet)) + " + " + _vm._s(_vm.currencyFormat(row.formula.dependantsNet)) + " ] - " + _vm._s(_vm.currencyFormat(row.formula.dependantsNet)))])])]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(row.dependencyMultiplicand)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(row.multiplier, 3)))]), _vm._v(" "), _c('td', [_c('em', [_vm._v("Table " + _vm._s(row.period == 'pre' ? 'E' : 'F') + " ")]), _vm._v("— " + _vm._s(_vm.roundValue(row.discountFactor, 2)) + "\n                ")]), _vm._v(" "), (_vm.theDeceased.income.contingencyMultiplier) ? _c('td', [_vm._v(_vm._s(_vm.roundValue(_vm.theDeceased.income.multiplier, 2)))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(_vm.roundValue(row.multiplier, 2)) + " x " + _vm._s(_vm.roundValue(row.discountFactor, 2)) + " "), (_vm.theDeceased.income.contingencyMultiplier) ? _c('span', [_vm._v("x " + _vm._s(_vm.roundValue(_vm.theDeceased.income.multiplier, 2)) + " ")]) : _vm._e(), _vm._v("= " + _vm._s(_vm.roundValue(row.discountedMultiplier, 2)) + "\n                ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(row.value)))])])
  }), 0)]) : _vm._e()]) : _c('div', {
    staticClass: "a-table a-table--short-no-style a-table--really-wide"
  }, [_c('div', {
    class: {
      'a-loader--table': !_vm.multiplierTable1and2.length
    }
  }), _vm._v(" "), (_vm.multiplierTable1and2.length) ? _c('div', [_c('h2', {
    staticClass: "a-table--non-white"
  }, [_vm._v("Pre-Assessment (" + _vm._s(_vm.dateFormat(_vm.multiplierTable1and2[0].pre.period_from.date, "DD/MM/YYYY")) + "\n                - " + _vm._s(_vm.dateFormat(_vm.multiplierTable1and2[0].pre.period_to.date, "DD/MM/YYYY")) + ")")]), _vm._v(" "), _c('table', {
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0",
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Period (years)")]), _vm._v(" "), _c('th', [_vm._v("Dependants")]), _vm._v(" "), _c('th', [_vm._v("Table 36")]), _vm._v(" "), _c('th', [_vm._v("Split %")]), _vm._v(" "), _c('th', [_vm._v("Table 1 and 2 ")]), _vm._v(" "), _c('th', [_vm._v("Discount Factor")]), _vm._v(" "), (_vm.theDeceased.income.contingencyMultiplier) ? _c('th', [_vm._v("Employment Contingency Multiplier")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("Discounted Multiplier")]), _vm._v(" "), _c('th', [_vm._v("Multiplicand")]), _vm._v(" "), _c('th', [_vm._v("Loss")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.multiplierTable1and2[0].pre.periods), function(period) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.roundValue(period.period, 2)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(period.dependants)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(period.table28, 2)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(period.split, 2)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(period.table1And2, 2)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(period.discountFactor, 2)))]), _vm._v(" "), (_vm.theDeceased.income.contingencyMultiplier) ? _c('td', [_vm._v(_vm._s(_vm.theDeceased.income.multiplier))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(period.discountMultiplier, 2)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(period.multiplicand)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(period.loss)))])])
  }), 0)]), _vm._v(" "), _c('h2', {
    staticClass: "a-table--non-white"
  }, [_vm._v("Post-Assessment (" + _vm._s(_vm.dateFormat(_vm.multiplierTable1and2[0].post.period_from.date, "DD/MM/YYYY")) + " -\n                " + _vm._s(_vm.dateFormat(_vm.multiplierTable1and2[0].post.period_to.date, "DD/MM/YYYY")) + ")")]), _vm._v(" "), _c('table', {
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0",
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Period (years)")]), _vm._v(" "), _c('th', [_vm._v("Dependants")]), _vm._v(" "), _c('th', [_vm._v("Table 36")]), _vm._v(" "), _c('th', [_vm._v("Split %")]), _vm._v(" "), _c('th', [_vm._v("Table 1 and 2 ")]), _vm._v(" "), _c('th', [_vm._v("Discount Factor")]), _vm._v(" "), (_vm.theDeceased.income.contingencyMultiplier) ? _c('th', [_vm._v("Employment Contingency Multiplier")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("Discounted Multiplier")]), _vm._v(" "), _c('th', [_vm._v("Multiplicand")]), _vm._v(" "), _c('th', [_vm._v("Loss")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.multiplierTable1and2[0].post.periods), function(period) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.roundValue(period.period, 2)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(period.dependants)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(period.table28, 2)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(period.split, 2)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(period.table1And2, 2)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(period.discountFactor, 2)))]), _vm._v(" "), (_vm.theDeceased.income.contingencyMultiplier) ? _c('td', [_vm._v(_vm._s(_vm.roundValue(_vm.theDeceased.income.multiplier, 2)))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(period.discountMultiplier, 2)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(period.multiplicand)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(period.loss)))])])
  }), 0)])]) : _vm._e()]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": 'multipliers_' + _vm.uniqueId,
      "no-default-button": "true"
    }
  }, [_c('modal-content')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-cc2c0502!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/fatal-accident-claims/dependency/steps/dependency-on-income/Multipliers.vue
// module id = 1809
// module chunks = 0